var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24203 6.05432C3.71886 6.05432 3.09017e-05 9.16475 3.09017e-05 12.9882C3.09017e-05 14.5165 0.592844 16.0697 1.67999 17.2736L0.144797 19.0279C0.0706792 19.1126 0.0225654 19.2169 0.00622736 19.3282C-0.0101106 19.4395 0.00602108 19.5532 0.0526872 19.6556C0.099117 19.7581 0.174112 19.8451 0.268692 19.9061C0.363272 19.9671 0.473428 19.9995 0.585969 19.9995H8.82797C12.1676 19.9995 16.484 17.1237 16.484 12.9882C16.484 9.16475 12.7652 6.05432 8.24203 6.05432ZM4.68742 14.0621C4.0414 14.0621 3.51558 13.5363 3.51558 12.8903C3.51558 12.2443 4.04144 11.7185 4.68742 11.7185C5.3334 11.7185 5.85926 12.2443 5.85926 12.8903C5.85929 13.5363 5.33344 14.0621 4.68742 14.0621ZM8.24203 14.0621C7.59602 14.0621 7.07019 13.5363 7.07019 12.8903C7.07019 12.2443 7.59605 11.7185 8.24203 11.7185C8.88801 11.7185 9.41387 12.2443 9.41387 12.8903C9.41387 13.5363 8.88805 14.0621 8.24203 14.0621ZM11.7966 14.0621C11.1506 14.0621 10.6248 13.5363 10.6248 12.8903C10.6248 12.2443 11.1507 11.7185 11.7966 11.7185C12.4426 11.7185 12.9685 12.2443 12.9685 12.8903C12.9685 13.5363 12.4427 14.0621 11.7966 14.0621Z",
    fill: "url(#paint0_linear_208_822)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8583 11.9227L18.4787 10.3132C19.4635 9.202 19.9996 7.847 19.9996 6.44516C19.9996 2.89129 16.5825 0 12.3826 0C8.58475 0 5.35815 2.36676 4.78842 5.44727C5.84811 5.08719 7.03651 4.88251 8.2421 4.88251C13.3731 4.88251 17.5886 8.4663 17.6502 12.8903H19.4137C19.9142 12.8904 20.183 12.301 19.8583 11.9227Z",
    fill: "url(#paint1_linear_208_822)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_822",
    x1: 0.0000306845,
    y1: 19.9995,
    x2: 17.8267,
    y2: 17.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD297E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B01FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_822",
    x1: 4.78842,
    y1: 12.8903,
    x2: 21.2398,
    y2: 11.0435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD297E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B01FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkApplication);
export default __webpack_public_path__ + "static/media/dark-application.e75d84afba9da3d766ef21d3a89ff24f.svg";
export { ForwardRef as ReactComponent };